import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzHlwn80 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_HLWN_80: Record<
  Exclude<PageIdWoofzHlwn80, PageIdWoofzHlwn80.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SUBSCRIPTIONS_PAGE_HLWN_80]: {
    id: PageId.SUBSCRIPTIONS_PAGE_HLWN_80,
    hasHeader: false,
  },
  [PageId.CHAT_UPSELL_HLWN_80]: {
    id: PageId.CHAT_UPSELL_HLWN_80,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_HLWN_80]: {
    id: PageId.UPSELL_HLWN_80,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_HLWN_80]: {
    id: PageId.DOWNLOAD_HLWN_80,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
